import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// Actions
import { triggerPopup } from '../../../actions/backdrop'
import { getCustomer } from '../../../actions/customers'
import { getShops } from '../../../actions/shops'
import { getPartner } from '../../../actions/workProvider'
import { getConstraints } from '../../../actions/agreement'
import { getPriceLists } from '../../../actions/priceModel'
// import styles
import './agreements.scss'

// import components
import Header from '../../../shared/components/Header'
// import LeftMenu from '../../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../../shared/components/Menus/LeftMenu/Content'

// Elements
import Button from '../../../shared/elements/button'
import Check from '../../../shared/elements/check'
import SideMenu from '../../../shared/elements/sideMenu'
import SideMenuCustomItem from '../../../shared/elements/sideMenuCustomItem'
import SideMenuItem from '../../../shared/elements/sideMenuItem'
import TabBar from '../../../shared/elements/tabBar'
import TabItem from '../../../shared/elements/tabItem'
import Text from '../../../shared/elements/text'

// Views
import AgreementDetails from './Details'
import View from '../View'
import Insurance from './Insurance'
import SelectCustomer from './SelectCustomer'
import QualityCheckSettingsChild from '../../QualityCheckSettings/QualityCheckSettingsChild'
import Delivery from '../../Settings/Delivery'

// Utils
import { translation } from '../../../utils/helpers'
import { hasAccess } from '../../../utils/auth'

class Agreements extends Component {

  constructor (props) {
    super(props)
    this.state = {
      list: [],
      search: '',
      includeInactive: true,
      includeConstraints: true,
      activeItem: {},
      constraints: [],
      partnerName: '',
      fetched: false,
      customerName: null,
      valid: [
        {
          name: 'salescar',
          access: [6]
        }
      ],
      selectedTabIndex: 0,
      agreementId: -1,
      selectedCustomerId: -1,
      selectedShopId: -1
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.onShouldUpdate = this.onShouldUpdate.bind(this)
    this.onClickCreate = this.onClickCreate.bind(this)
    this.onClickHeaderButton = this.onClickHeaderButton.bind(this)
    this.searchList = this.searchList.bind(this)
    this.filterList = this.filterList.bind(this)
    this.setActiveItem = this.setActiveItem.bind(this)
    this.selectCustomer = this.selectCustomer.bind(this)
    this.priceRoute = '/agreements'
  }

  componentDidMount () {
    this.getPartner(this.props)
    this.getPriceLists()
    if (typeof this.props.params.constraintID !== 'undefined') {
      this.setState({
        view: 'item',
        activeItem: {
          AgreementConstraintId: this.props.params.constraintID
        }
      })
    }
    if (this.props.route.customer) {
      this.getCustomer(this.props)
    }
    if (!this.hasAccessToPage()) {
      this.props.router.push(this.priceRoute)
    } else {
      /*
      this.getPriceLists()
      if (!isNaN(this.props.params.type)) {
        this.setState({
          agreementId: parseInt(this.props.params.type)
        })
      } */
    }
  }

  componentWillUpdate (nextProps) {
  }
  componentWillReceiveProps (nextProps) {
    if (!isNaN(nextProps.params.type)) {
      this.setState({
        agreementId: parseInt(nextProps.params.type)
      })
    }
  }

  componentDidUpdate () {
    if (!this.hasAccessToPage()) {
      this.props.router.push(this.priceRoute)
    } else {
      if (!this.state.fetched) {
        setTimeout(() => {
          if (this.state.list.length === 0) {
            this.getPriceLists()
          }
        }, 1000)
      }
    }
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    // if (view === 'create') {
    //   activeItem = {}
    // }
    activeItem = {}
    this.setState({
      view: view,
      activeItem: activeItem,
      constraints: this.state.constraints
    })

    this.props.router.replace(this.priceRoute + '/' + this.props.params.constraintID)
  }
  getPartner (props) {
    if (typeof props.params.WorkProviderId !== 'undefined') {
      props.getPartner(props.params.WorkProviderId).then((res) => {
        this.setState({
          partnerName: res.data.Name
        })
      }, (err) => {
        if (err.response.status === 401) {
          this.props.router.replace('/orders')
        }
      })
    }
  }

  hasAccessToPage () {
    let valid = true
    let found = false
    if (typeof this.props.params.type !== 'undefined') {
      this.state.valid.map((val, key) => {
        if (val.name === this.props.params.type) {
          found = true
          if (!hasAccess(val.access, this.props.auth.user.UserType)) {
            valid = false
          }
        }
      })
      if (!found) {
        if (hasAccess([6], this.props.auth.user.UserType)) {
          valid = true
        }
      }
    }
    return valid
  }

  selectCustomer (customerId, shopId) {
    if (typeof customerId === 'string') customerId = parseInt(customerId)
    if (typeof shopId === 'string') shopId = parseInt(shopId)
    // console.log('selected customer and shop', customerId, shopId)
    this.setState({
      selectedCustomerId: customerId,
      selectedShopId: shopId
    }, () => {
      // console.log('selectCustomer after setstate', this.state.selectedCustomerId, this.state.selectedShopId)
    })
  }

  getCustomer (props) {
    if (typeof props.params.customerID !== 'undefined') {
      props.getCustomer(props.params.customerID).then((res) => {
        this.setState({
          customerName: res.data.CompanyName
        })
      })
    }
  }
  getPriceLists () {
    this.props.getConstraints().then((res) => {
      this.setState({
        constraints: res.data
      }, () => {
        if (this.state.activeItem !== null) {
          this.setActiveItem(this.findPriceModelId(this.state.activeItem.AgreementConstraintId))
        }
      })
    })
    return this.props.getPriceLists().then((res) => {
      this.setState({
        list: res.data,
        fetched: true
        // customerName: customerName
      })
      return res
    }, () => {
      console.log('Err fetching price lists data')
      return null
    })
  }
  setActiveItem (val) {
    this.setState({
      view: 'item',
      activeItem: val
    })
  }

  onShouldUpdate () {
    this.setState({
      selectedTabIndex: 0
    }, () => {
      this.props.router.push(this.priceRoute + '/' + this.state.activeItem.AgreementConstraintId)
      this.getPriceLists().then(() => {
        // Toastr
        // window.toastr.success(translation('13444'), translation('13424'))
      }, () => {
        // Toastr
        window.toastr.error(translation('2018'), translation('216'))
      })
    })
  }

  searchList (e) {
    if (e.target.name === 'SearchText') {
      this.setState({
        search: e.target.value
      })
    }
    if (e.target.name === 'Inactive') {
      this.setState({
        includeInactive: e.target.checked
      })
    }
    if (e.target.name === 'chkConstraint') {
      this.setState({
        includeConstraints: e.target.checked
      })
    }
  }

  filterList (key) {
    if (key.AgreementConstraintName.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 &&
      (!this.state.includeInactive ? key.Active : true) &&
      (!this.state.includeConstraints ? key.PriceModelId > -1 : true)) {
      return true
    }
    return false
  }

  leftMenu () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.refs.view.getWrappedInstance().addConstraint()
      }

      return (
        <SideMenuCustomItem>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>
      )
    }

    let constraints = this.state.constraints
    let grouping = []
    for (let i = 0; i < constraints.length; i++) {
      let group = grouping.find((val, idx) => { return val.customerGroupName === constraints[i].CustomerGroupName })
      if (group === undefined) {
        group = {
          customerGroupName: constraints[i].CustomerGroupName,
          constraints: []
        }
        grouping.push(group)
      }
      group.constraints.push(constraints[i])
    }

    const renderGroup = (group, key) => {
      const renderItem = (val, key) => {
        // Classname
        let isSelected = false
        if (this.state.activeItem) {
          if (isEqual(val, this.state.activeItem) || parseInt(val.AgreementConstraintId) === parseInt(this.state.activeItem.AgreementConstraintId)) {
            isSelected = true
          }
        }

        // On select
        const selectItem = () => {
          this.setState({
            view: 'item',
            activeItem: val,
            selectedTabIndex: 0,
            constraints: this.state.constraints,
            selectedCustomerId: -1
          })
          this.props.router.replace(this.priceRoute + '/' + val.AgreementConstraintId)
        }

        let name = val.AgreementConstraintName
        if (val.Brand !== undefined && val.Brand !== null) {
          name += ' (' + val.Brand + ')'
        }

        return (
          <SideMenuItem
            label={name}
            onClick={selectItem}
            selected={isSelected}
            inactive={!val.Active || val.PriceModelId === -1}
            key={key}
          />
        )
      }

      let groupName = group.customerGroupName
      if (groupName === null) groupName = '(' + translation('12268') + ')'
      let filteredItems = group.constraints.filter(this.filterList)
      if (filteredItems === undefined || filteredItems === null || filteredItems.length === 0) return undefined

      return (
        <SideMenuItem
          label={groupName}
          isTitle
          key={key}
        >
          {filteredItems.map(renderItem)}
        </SideMenuItem>
      )
    }

    // Return
    return [
      <div key='filter'>
        <SideMenuCustomItem>
          <Text
            name='SearchText'
            value={this.state.search}
            onChange={this.searchList}
          />
        </SideMenuCustomItem>
        <SideMenuCustomItem>
          <Check
            name='Inactive'
            checked={this.state.includeInactive === true}
            onChange={this.searchList}
            labelText={translation('1859')}
            spacing={0}
          />
        </SideMenuCustomItem>
        <SideMenuCustomItem>
          <Check
            name='chkConstraint'
            checked={this.state.includeConstraints === true}
            onChange={this.searchList}
            labelText={translation('12269')}
            spacing={0}
          />
        </SideMenuCustomItem>
      </div>,

      ...grouping.map(renderGroup)
    ]
  }
  renderHeaderTitle () {
    let customerName = this.state.customerName
    return (customerName !== null) ? translation('12270') + ' - ' + customerName : translation('12270')
  }

  findPriceModelId (constraintId) {
    let item = null
    this.state.constraints.map((val, key) => {
      if (val.AgreementConstraintId === constraintId) {
        item = val
      }
    })
    return item
  }

  renderView () {
    if (this.state.list.length === 0) return null
    let item = null
    let view = null
    let classname = 'agreements__screen--inner'
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
      case 'item':
        if (this.state.activeItem === null) return undefined
        item = (this.state.activeItem.PriceModelId > 0)
          ? this.findPriceModelId(parseInt(this.props.params.type))
          : this.state.activeItem
        let pricetype = Number(this.state.activeItem.PriceType)
        switch (this.state.selectedTabIndex) {
          case 0: // Main agreement
            if (this.state.activeItem.PriceModelId <= 0) {
              view = <View router={this.props.router} ref='view' item={this.state.activeItem} pricemodels={this.state.list} getPriceLists={this.getPriceLists.bind(this)} />
              classname = 'constraints__screen--inner'
              break
            }
            if (pricetype !== 5 && pricetype !== 6 && pricetype !== 0 && !this.state.activeItem.UseEstimationList) {
              if (item !== null) {
                view = <AgreementDetails
                  router={this.props.router}
                  onShouldUpdate={this.onShouldUpdate}
                  selectedTabIndex={this.state.selectedTabIndex}
                  item={item}
                  isMain
                  selectedCustomerId={-1}
                  customer={this.props.route.customer}
                  partners={this.props.route.partners}
                  agreementId={this.state.activeItem.PriceModelId}
                  getPriceLists={this.getPriceLists.bind(this)} />
              }
            } else {
              if (this.state.activeItem.PriceModelId > 0) item = this.findPriceModelId(parseInt(this.props.params.type))
              view = <Insurance ref='view'
                router={this.props.router}
                selectedTabIndex={this.state.selectedTabIndex}
                onShouldUpdate={this.onShouldUpdate}
                item={item}
                isMain
                selectedCustomerId={-1}
                pricemodels={this.state.list}
                agreementId={this.state.activeItem.PriceModelId}
                getPriceLists={this.getPriceLists.bind(this)} />
            }
            break
          case 1: // SubAgreement
            view = <SelectCustomer
              onShouldUpdate={this.onShouldUpdate}
              selectedTabIndex={this.state.selectedTabIndex}
              item={item}
              setActiveItem={this.setActiveItem.bind(this)}
              customer={this.props.route.customer}
              partners={this.props.route.partners}
              agreementId={this.state.activeItem.PriceModelId}
              getPriceLists={this.getPriceLists.bind(this)}
              selectCustomer={this.selectCustomer.bind(this)}
              selectedCustomerId={this.state.selectedCustomerId}
              selectedShopId={this.state.selectedShopId} />
            break
          case 2: // Quality Check
            view = <QualityCheckSettingsChild ref='view'
              selectedTabIndex={this.state.selectedCustomerTab}
              onShouldUpdate={this.props.onShouldUpdate}
              isMainAgreement
              item={this.state.activeItem}
              selectedCustomerId={0}
              pricemodels={this.props.pricemodels}
              agreementId={this.state.activeItem.PriceModelId}
              getPriceLists={this.props.getPriceLists.bind(this)} />
            break
          case 3: // Delivery
            view = <Delivery ref='view'
              selectedTabIndex={this.state.selectedCustomerTab}
              onShouldUpdate={this.props.onShouldUpdate}
              isMainAgreement
              isShop={false}
              selectedCustomerId={0}
              pricemodels={this.props.pricemodels}
              agreementId={this.state.activeItem.PriceModelId}
              getPriceLists={this.props.getPriceLists.bind(this)} />
            break
          default:
            view = <View router={this.props.router} ref='view' item={this.state.activeItem} pricemodels={this.state.list} getPriceLists={this.getPriceLists.bind(this)} />
            classname = 'constraints__screen--inner'
            break
        }

        return (
          <LeftMenuContent className={classname}>
            {view}
          </LeftMenuContent>
        )
    }
  }

  onClickCreate () {
    this.props.router.push('/agreements/')
  }
  onClickHeaderButton (e) {
    let val = e.target.value
    let btn = e.target.name
    if (btn === 'btnTab') {
      e.preventDefault()
      this.setState({
        selectedTabIndex: Number(val)
      }, () => {
        if (this.state.selectedTabIndex === 0) {
        }
      })
    }
  }
  headerButtonsRight () {
    // if (this.props.route.customer) return null
    if (!hasAccess([6], this.props.auth.user.UserType)) return null
    const buttonClass = (val) => {
      let btn = ''
      if (val === this.state.selectedTabIndex) return 'active'
      return btn
    }
    const priceModelButtons = () => {
      if (!this.state.activeItem) return false
      if (this.state.activeItem.PriceModelId <= 0) {
        return undefined
      }
      let isAddon = this.state.activeItem.PriceType === 8
      const onTabClick = (e) => {
        this.setState({
          selectedTabIndex: e
        })
      }
      return (
        <TabBar>
          <TabItem><div name='btnTab' onClick={() => onTabClick(0)} className={buttonClass(0)}>{translation('13472')}</div></TabItem>
          <TabItem><div name='btnTab' onClick={() => onTabClick(1)} className={buttonClass(1)}>{translation('1737')}</div></TabItem>
          {!isAddon && (<TabItem><div name='btnTab' onClick={() => onTabClick(2)} className={buttonClass(2)}>{translation('13421')}</div></TabItem>)}
          {!isAddon && (<TabItem><div name='btnTab' onClick={() => onTabClick(3)} className={buttonClass(3)}>{translation('196')}</div></TabItem>)}
        </TabBar>)
    }
    return (
      <div>
        {priceModelButtons()}
      </div>
    )
  }

  render () {
    let headerButtonsGoBack
    headerButtonsGoBack = (router, t) => {
      const goBack = () => {
        this.props.router.replace({
          pathname: '/customers',
          query: {
            customerId: this.props.params.customerID
          }
        })
      }
      if (!this.props.route.customer) return null
      return (
        <div key='back_close'>
          <div className='alignHelper' />
          <div className='hint--left' aria-label={t('2060')}><img src='/images/icons/close_24.png' onClick={goBack} className='icon' /></div>
        </div>
      )
    }
    let classname = 'constraints__screen'
    if (this.state.activeItem !== null && this.state.activeItem.PriceModelId > 0) classname = 'prices__screen'
    return (
      <div className={classname}>
        {/* <Header router={this.props.router} title={this.renderHeaderTitle()} icon={'menu/Prices-White.png'} renderRight={this.headerButtonsRight} showBack={this.props.route.customer} headerButtonsGoBack={headerButtonsGoBack} /> */}
        <Header router={this.props.router} renderRight={this.headerButtonsRight} showBack={this.props.route.customer} headerButtonsGoBack={headerButtonsGoBack} />

        <SideMenu disableFilter>
          {this.leftMenu()}
        </SideMenu>

        {this.renderView()}
      </div>
    )
  }

}

Agreements.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    selectedTabIndex: state.selectedTabIndex,
    agreementId: state.agreementId,
    pricemodels: state.pricemodels,
    selectedCustomerId: state.selectedCustomerId
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  getCustomer,
  getShops,
  getConstraints,
  getPartner,
  getPriceLists
})(Agreements)



// WEBPACK FOOTER //
// ./src/app/pages/PriceAgreements/Agreements/index.js